import { http, HttpResponse } from 'msw';

import { clusterFixtures } from '../../fixtures/cluster.fixture';
import { estimatedSavingsFixtures } from '../../fixtures/estimatedSavings.fixture';

const handlers = [
  http.get('/api/v1/kubernetes/external-clusters', () => {
    return HttpResponse.json({ items: [clusterFixtures.cluster.entity] });
  }),
  http.get('/api/v1/kubernetes/external-clusters/operations/:id', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/external-clusters/:clusterId', () => {
    return HttpResponse.json(clusterFixtures.cluster.entity);
  }),
  http.get(
    '/api/v1/kubernetes/external-clusters/:clusterId/estimated-savings',
    () => {
      return HttpResponse.json(estimatedSavingsFixtures.savings.response);
    }
  ),
  http.get(
    '/api/v1/kubernetes/external-clusters/:clusterId/credentials-script',
    () => {
      return HttpResponse.json({ script: 'script' });
    }
  ),
  http.get('/api/v1/kubernetes/external-clusters/kubeconfig', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/external-clusters/metrics', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/external-clusters/:clusterId/nodes', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/kubernetes/external-clusters/nodes/:nodeId', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
